import type {ReactNode} from 'react'
import {
  TarjetaAntiguedad,
  TarjetaConfirmar,
  TarjetaEscribir,
  type FocoEscritura,
} from '@/components/bateria/cola/tarjeta-campo'
import type {GestoEnCurso} from '@/components/bateria/cola/gesto-en-curso'
import {OPCIONES_ANTIGUEDAD, type GestoGuardado, type TarjetaCola} from '@/lib/bateria-cola'

/** Las tres contestan por `onElegir`, incluida la de escribir: así el gesto en curso viaja con la respuesta. */
export function TarjetaDeFicha({
  tarjeta,
  opciones,
  posicion,
  seleccion,
  gestos,
  borrador,
  foco,
  puedeDecidir,
  onElegir,
  onEscribir,
  onCambiar,
  onSoltarFoco,
  onDespues,
  onAtras,
  onAdelante,
  businessId,
  evaluacionId,
}: {
  tarjeta: TarjetaCola
  opciones: string[]
  posicion: ReactNode
  seleccion: string | null
  puedeDecidir: boolean
  gestos: {
    gesto: GestoEnCurso
    gestoGuardado: GestoGuardado
    casillasGuardadas: readonly string[]
    onSenalar: (valor: string) => void
    clicSenala: boolean
  }
  borrador: string
  foco: FocoEscritura
  onElegir: (valor: string | null) => void
  onEscribir: () => void
  onCambiar: (valor: string) => void
  onSoltarFoco: () => void
  onDespues: () => void
  onAtras: () => void
  onAdelante: () => void
  businessId: string
  evaluacionId: string
}) {
  const comun = {
    tarjeta,
    posicion,
    seleccion,
    gestos,
    puedeDecidir,
    onElegir,
    onDespues,
    onAtras,
    onAdelante,
    businessId,
    evaluacionId,
  }
  if (tarjeta.tipo === 'confirmar') return <TarjetaConfirmar {...comun} opciones={opciones} />
  if (tarjeta.tipo === 'antiguedad')
    return (
      <TarjetaAntiguedad
        {...comun}
        opciones={OPCIONES_ANTIGUEDAD}
        anios={borrador}
        foco={foco}
        onEscribirAnios={onEscribir}
        onCambiarAnios={onCambiar}
        onConfirmarAnios={() => onElegir(borrador.trim() || null)}
        onSoltarFoco={onSoltarFoco}
      />
    )
  return (
    <TarjetaEscribir
      tarjeta={tarjeta}
      valor={borrador}
      posicion={posicion}
      foco={foco}
      puedeDecidir={puedeDecidir}
      onCambiar={onCambiar}
      onConfirmar={() => onElegir(borrador.trim() || null)}
      onSoltarFoco={onSoltarFoco}
      onDespues={onDespues}
      onAtras={onAtras}
      onAdelante={onAdelante}
      businessId={businessId}
      evaluacionId={evaluacionId}
    />
  )
}
